const RAZORPAYX_ROOT = 'razorpayx'

export const razorpayxRoutes = {
  link: () => `${RAZORPAYX_ROOT}/link`,
  check: () => `${RAZORPAYX_ROOT}`
}
